/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useEffect, useState } from 'react'
import { LinkIcon } from '../LandingHeader/Feedback/icons/Icons';
import { TODOIST } from '../common/constants';
import DisconnectOptionsModal from './DisconnectOptionsModal';
import { useDispatch } from 'react-redux';
import { pushToSetting } from '../../redux/slices/SettingSclice';
import ConnectConfirmModal from "./ConnectConfirmModal";

const Todoist = ({fetchSettingData, settings, theme, colorPicker}) => {
    const [showDisconnectOptionsModal, setShowDisconnectOptionsModal] = useState(false);
    const [isTodoistConnected, setIsTodoistConnected] = useState(settings?.todoist_verification_token?.length > 0);
    const [showConnectModal, setShowConnectModal] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        const status = settings?.todoist_verification_token?.length > 0;
        if(isTodoistConnected !== status){
            setIsTodoistConnected(status);
            if(status){
                setShowConnectModal(true);
            }
        }
    }, [settings])

    const popupWindow = (url, w, h) => {
        const y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
        const x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
    
        return window.open(url, 'Todoist Auth', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
    }

    const disconnectTodoist = (disconnect = false) => {
        setShowDisconnectOptionsModal(false);
        if(disconnect){
            dispatch(pushToSetting({ ...settings, todoist_verification_token: '' }));
        }
    }

    const confirmDisconnect = (e) => {
        e?.preventDefault();
        setShowDisconnectOptionsModal(true);
    }
    
    const connectTodoist = (e) => {
        e.preventDefault();
        const api = `${TODOIST.API}?client_id=${TODOIST.CLIENT_ID}&scope=${TODOIST.SCOPE}&state=${localStorage.getItem('token')}`;
        const popup = popupWindow(api, 600, 600);
        const interval = setInterval(() => {
            if (popup.closed) {
                clearInterval(interval);
                //console.log('Popup Closed');
                fetchSettingData();
            }
        }, 500);
    }
    return (
        <>  
            <div className='flex items-center relative'>
                <img src="images/logos_todoist-icon.svg" />
                <label className="field-label dark:text-white dark:opacity-70 m-0 ml-[10px] !mb-0 mr-[10px]">Todoist Integration</label>
                {settings?.todoist_verification_token?.length > 0 && <span className="flex items-center gap-1"><LinkIcon color={`var(--accent-color)`} /> <span className="accent-text-color font-bold text-[16px] leading-[19px]">Connected</span></span>}
            </div>
            <div className="field-info dark:text-white text-[#909090] relative">Enjoy a 2-way sync between your scheduled Todoist tasks and LifeTab.</div> 
            <div className="field-button mt-[10px]">
            {
                settings?.todoist_verification_token?.length > 0
                ?
                <button className="cancel"
                onClick={confirmDisconnect}
                style={{
                background:theme == "dark" && ((theme == "dark" && colorPicker == "#ef233c") ?
                    `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), #3A86FF` :
                    (theme == "dark" && colorPicker == "#f8961e") ?
                    `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), #27CB9A`
                    : (theme == "dark" && colorPicker == "#27cb9a") ?
                        `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), var(--overDue-color)` :
                        (theme == "dark" && colorPicker == "#4cc9f0") ?
                        `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), var(--overDue-color)` :
                        (theme == "dark" && colorPicker == "#3a86ff") ?
                            `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), var(--overDue-color)` :
                            (theme == "dark" && colorPicker == "#9b5de5") ?
                            `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), #F8961E` :
                            (theme == "dark" && colorPicker == "#ef476f") ?
                                `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), #3A86FF` :
                                `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), rgb(217, 85, 85)`),
                color:theme == "dark" && ((theme == "dark" && colorPicker == "#ef233c") ? "#3A86FF" : (theme == "dark" && colorPicker == "#f8961e") ? "#27CB9A" : (theme == "dark" && colorPicker == "#9b5de5") ? "#F8961E" : (theme == "dark" && colorPicker == "#ef476f") ? "#3A86FF" : "rgb(217, 85, 85)")
                }}
                >Disconnect</button>
                :
                <button className="changeName"
                    onClick={connectTodoist}
                    css={{
                        background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.05), rgba(var(--theme-mode-rgb-white-reverse), 0.05)), var(--theme-mode-color-white) !important`,
                        color: `var(--accent-color) !important`
                    }}
                >Connect Todoist</button>
            }
            </div>
            {
                showDisconnectOptionsModal && <DisconnectOptionsModal show={true} onHide={disconnect => disconnectTodoist(disconnect)} theme={theme} />
            }

            {
                showConnectModal && <ConnectConfirmModal show={true} onHide={e => setShowConnectModal(false)} theme={theme} />
            }
        </>
    )
}

export default Todoist